import { render, staticRenderFns } from "./index.vue?vue&type=template&id=568a0cd4"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=568a0cd4&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('568a0cd4')) {
      api.createRecord('568a0cd4', component.options)
    } else {
      api.reload('568a0cd4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=568a0cd4", function () {
      api.rerender('568a0cd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wechatapp/index.vue"
export default component.exports